"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)(_components.Dialog, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['zIndex'])
})(({
  zIndex
}) => ({
  zIndex,
  button: {
    zIndex: typeof zIndex === 'number' ? zIndex + 1 : undefined
  },
  [`& .${_components.dialogClasses.closeButton}`]: {
    zIndex: 10
  }
}));